export enum SimpleSearchOrigin {
  ADVANCED_SEARCH = 'ADVANCED_SEARCH',
  ALL_ITEMS = 'ALL_ITEMS',
  SEARCHBOX = 'SEARCHBOX',
  WORKLIST = 'WORKLIST',
}

export interface ISimpleSearchWorklistMappingItem {
  filterComponentName: string;
  filterParameterName: string;
  nameInSearchResult: string;
  nameInWorklist: string;
}

export interface ISimpleSearchFilterParameter {
  paramName: string;
  paramValue: string;
}

export interface ISimpleSearchQuery {
  _count: number;
  _countOnly?: boolean;
  _fieldslist: string;
  _page: number;
  _sort: string;
  active: boolean;
  searchAgg?: any;
}

export interface ISimpleSearchConfig {
  active: boolean;
  allItemFilterParamName: string;
  chunkSize: number;
  fieldslist: string;
  filters?: Array<ISimpleSearchFilterParameter>;
  resourceType: string;
  searchLevel: string;
  searchableFields: Array<string>;
  simpleSearchWorklistMapping: Array<ISimpleSearchWorklistMappingItem>;
  sortByField: string;
  sortByOrder: number;
}
